import { adaptToActiveFilters } from 'adapters/v1/filters/table';
import hash from 'object-hash';

export const mapTableToPropsFactory = (key) => {
  return (store) => {
    const {
      [key]: { loading, data, result, meta, filters, query, initialState, storeStateId, schema },
    } = store;

    // Omit transient fields from the hash so stateId stays stable across
    // page/sort changes. page is kept in Redux query so Table.js can include
    // it when refetching, but excluded from the hash to prevent stateId churn.
    // IMPORTANT: Use destructuring instead of delete to avoid mutating Redux state.
    const { sort, dir, count, include, showAll, page, ...queryForHash } = query;
    const { per_page, search } = query;

    const activeFilters = adaptToActiveFilters(filters);

    // stateId drives Table.js's refetch effect. It should change when the
    // user's query intent changes (search, filters, per_page) or when an
    // explicit refresh is requested (storeStateId via triggerState()).
    // Previously, `result` was included as a trigger when filters were
    // active, but result changes on every page change, causing a redundant
    // second fetch after every pagination click.
    const stateId = hash({ query: queryForHash, storeStateId });

    return {
      stateId,
      initialState,
      data: result.map((id) => data[id]),
      activeFilters,
      loading,
      search,
      schema,
      per_page,
      query,
      ...meta,
    };
  };
};

export const mergePropsToTable = (propsFromState, propsFromDispatch, ownProps) => {
  const { query } = propsFromState;
  const { list, listByUser, updateQuery } = propsFromDispatch;
  // Handle case where a userId is specifically passed to the table
  // for use in user specific tables.
  const { userId } = ownProps;

  if (!list || !updateQuery)
    throw new Error(
      "ContractViolation: Missing required dispatch actions 'list' and/or 'updateQuery'"
    );
  if (!query) throw new Error("ContractViolation: Missing required store object 'query'");

  // For Search, Pagination, Table, and ActiveFilter components
  const _list = (queryParams) => {
    if (listByUser && userId) return listByUser(userId, { ...query, ...queryParams });
    return list({ ...query, ...queryParams });
  };

  // For Search Component
  const onSearch = (term) => {
    updateQuery({ query: { search: term } });
  };

  // For ActiveFilters Component
  const onCancelPil = (filterName) =>
    updateQuery({
      filters: { [filterName]: null },
    });

  return {
    ...propsFromState,
    ...propsFromDispatch,
    ...ownProps,
    list: _list,
    onCancelPil,
    onSearch,
  };
};
